import {
  CLAUDIA_INPUT_LIMITS,
  CLAUDIA_INPUT_TOO_LARGE_CODE,
} from "@repo/convex/assistant/inputLimits";
import {
  CLAUDIA_QUOTA_EXCEEDED_CODE,
  CLAUDIA_RATE_LIMITED_CODE,
} from "@repo/convex/assistant/rateLimitErrors";
import { APP_ERROR_CODES, isAppErrorData } from "@repo/shared";
import { ConvexError } from "convex/values";
import { getErrorMessage } from "@/lib/app-errors";

export const CLAUDIA_PROMPT_CHAR_LIMIT = CLAUDIA_INPUT_LIMITS.promptChars;

export function getAssistantErrorMessage(cause: unknown, fallback: string): string {
  const message = cause instanceof Error ? cause.message : fallback;
  if (message.includes(CLAUDIA_INPUT_TOO_LARGE_CODE)) {
    return `That message is too long. Keep it under ${CLAUDIA_PROMPT_CHAR_LIMIT.toLocaleString()} characters.`;
  }
  if (message.includes(CLAUDIA_RATE_LIMITED_CODE)) {
    return "Claudia is receiving too many requests. Wait a moment, then try again.";
  }
  if (message.includes(CLAUDIA_QUOTA_EXCEEDED_CODE)) {
    return "Claudia has reached today's usage limit for this workspace.";
  }
  return getErrorMessage(cause, fallback);
}

export function isThreadUnavailableError(cause: unknown): boolean {
  return (
    cause instanceof ConvexError &&
    isAppErrorData(cause.data) &&
    cause.data.code === APP_ERROR_CODES.THREAD_UNAVAILABLE
  );
}
